import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import Modal from '../../../common/Modal'
import ModalInnerWrapper from '../../../common/ModalInnerWrapper'
import PannelBody from '../../../fragments/PannelBody'
import Backdrop from '../../../common/modal/Backdrop'
import BodySimpleModalV3 from '../../../common/modal/BodySimpleModalV3'
import { restoreCaseDocumentApi } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { caseActions } from '../../../../store/case'

import classes from './DocumentsTabListItem.module.css'

export default function RestoreDocument({ document: documentItem }) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)
    const [modalOpened, setModalOpened] = useState(false)

    const openModalHandler = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setModalOpened(true)
    }

    const closeModalHandler = (event) => {
        event?.preventDefault?.()
        event?.stopPropagation?.()
        setModalOpened(false)
    }

    const restoreHandler = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        if (loading) {
            return
        }

        setLoading(true)
        try {
            const result = await restoreCaseDocumentApi(
                userToken,
                activeCase.case.id,
                documentItem.id,
                dispatch
            )

            if (result && result.errorMessage) {
                dispatch(notificationActions.setError(result))
            } else if (result) {
                dispatch(caseActions.replaceWholeItemInDocuments({ payload: result }))
                dispatch(notificationActions.setError({ errorMessage: 'success', type: 'success' }))
                setModalOpened(false)
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <BodySimpleModalV3 message="Restore document">
                <Button
                    btnStyle="btn_simple"
                    click={openModalHandler}
                    type="button"
                >
                    <i className="ti ti-arrow-back-up" />
                    <span className="sr-only">Restore document</span>
                </Button>
            </BodySimpleModalV3>
            {modalOpened && (
                <>
                    {ReactDOM.createPortal(
                        <Backdrop hide={closeModalHandler} />,
                        document.getElementById('backdrop-root')
                    )}
                    {ReactDOM.createPortal(
                        <Modal>
                            <ModalInnerWrapper closeModal={closeModalHandler} modalTitle="Restore document?">
                                <PannelBody>
                                    <form onSubmit={restoreHandler}>
                                        <p className="font-14">
                                            This document will be moved back to the active list and included in case logic again.
                                        </p>
                                        <p className="font-14 m-top-12">
                                            Related case flags will be rechecked based on all active documents.
                                        </p>
                                        <div className={`flex-container-equal m-top-24 ${classes.delete_document_actions}`}>
                                            <Button type="submit" isLoading={loading}>
                                                <i className="ti ti-arrow-back-up" /> Yes, restore
                                            </Button>
                                            <Button click={closeModalHandler} type="button">
                                                Cancel
                                            </Button>
                                        </div>
                                    </form>
                                </PannelBody>
                            </ModalInnerWrapper>
                        </Modal>,
                        document.getElementById('overlay-root')
                    )}
                </>
            )}
        </>
    )
}
